import { THintType } from "./InspectorHintTypes";
import { ReferenceGuideHint } from "./ReferenceGuideHint/ReferenceGuideHint";

export const defaultNodeHintType: THintType = "ref_guide";

export const hintMap = {
	["ref_guide"]: ReferenceGuideHint
} as const;

export const getHintComponent = <T extends THintType>(hintType: T): typeof hintMap[T] => hintMap[hintType];
